import { useEffect, useRef, useState } from 'react';

import useLoaderStore from '@/stores/useLoaderStore';

import {
    Selector as PropsSelector,
    Container as PropsContainer,
} from '@/models/Props';

import { ImgLazy } from '@/components/blocks';
import { LFlexSystem } from '@/components/layouts';

import './Header.scss';

const Header = ({ ariaLabel, company }: PropsSelector & PropsContainer) => {
    const [logo, setLogo] = useState(null);

    const hideLoader = useRef(useLoaderStore((state) => state.hideLoader));

    const getAsset = async () => {
        const img = await import(`../../../assets/img/white/${company}.png`);

        setLogo(img.default);
        hideLoader.current?.();
    };

    useEffect(() => {
        if (company) {
            getAsset();
        }
    });

    return (
        <header aria-label={ariaLabel} className={'header-container'}>
            <LFlexSystem
                className={`header-logo ${company}`}
                sortChildren={'rows'}
                positioning={{ alignItems: 'start' }}
            >
                {logo ? <ImgLazy src={logo} alt={'Logo'} /> : null}
            </LFlexSystem>
        </header>
    );
};

export default Header;
